import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import FrontCompanyModuleTypes from '@/store/modules/frontDesk/company/interface';

const frontCompanyModule: Module<FrontCompanyModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
      getCompany(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/index/anon/getCompany", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },

      pagePrototypeRoomList(context, searchParams) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/index/anon/pagePrototypeRoomList", searchParams).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },

      pageActivityList(context, searchParams) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/activity/anon/pageActivityList", searchParams).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
      
      listProject(context, searchParams) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/index/anon/listProject", searchParams).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
    
      saveRssActivity(context, params) {
        return new Promise((resolve, reject) => {
            tool.post("/personalCenter/saveRssActivity", params).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
    
    },
    
};

export default frontCompanyModule;